module.exports = __webpack_public_path__ + "static/media/comments-small.53749d6c.svg";